(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MessageSearch', MessageSearch);

    MessageSearch.$inject = ['$resource', 'ENV'];

    function MessageSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
